module.exports = __webpack_public_path__ + "img/logo_en.02c6e4a7.svg";